import styled from 'styled-components';
import {
	Card,
	TableRow,
	TableCell,
	TableHeaderCell,
} from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../../enums';

export const NoWrapTR = styled(TableRow)`
	white-space: nowrap;

	${TableCell},
	${TableHeaderCell} {
		padding: 10px 20px;
		text-align: center;
		vertical-align: middle;
	}
`;

const unaligned = `
    text-align: left !important;
`;

export const UnalignedCell = styled(TableCell)`
	${unaligned}
`;
export const UnalignedHeaderCell = styled(TableHeaderCell)`
	${unaligned}
`;

export const PlanProfileCard = styled(Card)`
	@media (max-width: ${ScreenSize.small}) {
		display: none;
	}
`;
